













  import { mixins } from 'vue-class-component';
  import { Component, Prop } from 'vue-property-decorator';
  import StaggeringTransitionGroup from '../animations/staggering-transition-group.vue';
  import DisableAnimationMixin from './disable-animation.mixin';

  /**
   * Renders a transition group wrapping the elements passed in the default slot and animating
   * them with an staggered fade and slide animation.
   *
   * @public
   */
  @Component({
    components: { StaggeringTransitionGroup },
    inheritAttrs: false
  })
  export default class StaggeredFadeAndSlide extends mixins(DisableAnimationMixin) {
    /**
     * Indicates if the transition must be applied on the initial render of the node.
     */
    @Prop({
      type: Boolean,
      default: true
    })
    public appear!: boolean;
    /**
     * The name of the animation.
     *
     * @public
     */
    protected animationName = 'x-staggered-fade-and-slide-';
  }
